import React from 'react';
import { Outlet } from 'react-router-dom';

import Footer from '@app/components/UI/Footer/Footer';
import HeaderNew from '@app/components/UI/Header/HeaderNew';

import '@app/scss/style.scss';

const LayoutMain: React.FC = () => {
	return (
		<div className="app-container">
			<HeaderNew />
			<Outlet />
			<Footer />
		</div>
	);
};

export default LayoutMain;
